const requestHandler = {
  state: {
    loading: false,
    errorMsg: null,
    successMsg: null
  },
  actions: {
    SET_SUCCESS_MESSAGE: (context, msg) => {
      context.commit('SET_SUCCESS', msg);
    },
    SET_ERROR_MESSAGE: (context, msg) => {
      context.commit('SET_ERROR', msg);
    },
    SET_LOADING: (context, loading) => {
      context.commit('SET_LOADING', loading);
    },
  },
  mutations: {
    SET_SUCCESS: (state, msg) => {
      state.successMsg = msg;
      state.errorMsg = null;
    },
    SET_ERROR: (state, msg) => {
      state.errorMsg = msg;
      state.successMsg = null;
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading;
    }
  },
  getters: {
    errorMessage: (state) => state.errorMsg,
    successMessage: state => state.successMsg,
    isLoading: (state) => state.loading
  }
};

export default requestHandler;